module.exports = __webpack_public_path__ + "static/media/Layer_x0020_1.545e9b6a.svg";